import React from 'react';
import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { SearchFormValues, searchSchema } from '../../schema';

import { BasicInfoTab } from './tabs/BasicInfoTab';
import { useSearchFieldsState } from '../../hooks';
import { DetailTab } from './tabs/DetailTab';

interface SearchDialogProps {
  openSearchDialog: boolean;
  onCloseSearchDialog: () => void;
  onSearch: (data: SearchFormValues) => void;
  initialData?: SearchFormValues;
}

export const SearchDialog: React.FC<SearchDialogProps> = ({
  openSearchDialog,
  onCloseSearchDialog,
  onSearch,
  initialData
}) => {
  const {
    selectedDepartment,
    setSelectedDepartment,
    selectedWarehouse,
    setSelectedWarehouse,
    selectedObject,
    setSelectedObject,
    selectedProduct,
    setSelectedProduct,
    selectedMaterial,
    setSelectedMaterial,
    selectedImportWarehouse,
    setSelectedImportWarehouse,
    selectedFromPosition,
    setSelectedFromPosition,
    selectedToPosition,
    setSelectedToPosition,
    selectedLot,
    setSelectedLot,
    selectedUnit,
    setSelectedUnit
  } = useSearchFieldsState();

  const formMode = 'search';

  const handleSubmit = (data: SearchFormValues) => {
    // Include search field data in the submission
    const searchData = {
      ...data,
      // Basic Info Tab search fields
      ma_kho_xuat: selectedWarehouse?.uuid || selectedWarehouse?.ma_kho,

      // Detail Tab search fields
      ma_vt: selectedMaterial?.uuid || selectedMaterial?.ma_vt,
      ma_kho_nhap: selectedImportWarehouse?.uuid || selectedImportWarehouse?.ma_kho,
      ma_vi_tri_tu: selectedFromPosition?.uuid || selectedFromPosition?.ma_vi_tri,
      ma_vi_tri_den: selectedToPosition?.uuid || selectedToPosition?.ma_vi_tri,
      ma_lo: selectedLot?.uuid || selectedLot?.ma_lo,
      ma_don_vi: selectedUnit?.uuid || selectedUnit?.ma_don_vi
    };

    onSearch(searchData);
    onCloseSearchDialog();
  };

  return (
    <DialogV2
      open={openSearchDialog}
      onClose={onCloseSearchDialog}
      title='Lọc phiếu nhập điều chuyển'
      maxWidth='xl'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='search'
        hasAritoActionBar={false}
        schema={searchSchema}
        onSubmit={handleSubmit}
        initialData={initialData}
        className='w-[900px]'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
            <BasicInfoTab
              formMode={formMode}
              selectedWarehouse={selectedWarehouse}
              setSelectedWarehouse={setSelectedWarehouse}
            />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'detail_tab',
                  label: 'Chi tiết',
                  component: (
                    <DetailTab
                      formMode={formMode}
                      selectedDepartment={selectedDepartment}
                      setSelectedDepartment={setSelectedDepartment}
                      selectedWarehouse={selectedWarehouse}
                      setSelectedWarehouse={setSelectedWarehouse}
                      selectedObject={selectedObject}
                      setSelectedObject={setSelectedObject}
                      selectedProduct={selectedProduct}
                      setSelectedProduct={setSelectedProduct}
                      selectedMaterial={selectedMaterial}
                      setSelectedMaterial={setSelectedMaterial}
                      selectedImportWarehouse={selectedImportWarehouse}
                      setSelectedImportWarehouse={setSelectedImportWarehouse}
                      selectedFromPosition={selectedFromPosition}
                      setSelectedFromPosition={setSelectedFromPosition}
                      selectedToPosition={selectedToPosition}
                      setSelectedToPosition={setSelectedToPosition}
                      selectedLot={selectedLot}
                      setSelectedLot={setSelectedLot}
                      selectedUnit={selectedUnit}
                      setSelectedUnit={setSelectedUnit}
                    />
                  )
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='search' onClose={onCloseSearchDialog} />}
      />
    </DialogV2>
  );
};

export default SearchDialog;
